module.exports = __webpack_public_path__ + "static/media/18_TOP_FRENTE_UNICA_COM_BOJO_ESTAMPADO_01.88dac04b.jpg";